import React, { useState } from "react";
import { showSuccessToast } from "src/lib/utils";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { uploadCustomers } from "src/api/customer";
import { usePortalContext } from "src/context/PortalContext";
import { Button } from "../ui/button";

const BulkCustomerModal = () => {
	const queryClient = useQueryClient();
	const closePortal = usePortalContext();

	const [file, setFile] = useState(null);

	const handleFileChange = (e) => {
		setFile(e.target.files[0]);
	};

	const handleDrop = (e) => {
		e.preventDefault();
		const droppedFile = e.dataTransfer.files[0];
		setFile(droppedFile);
	};

	const handleDragOver = (e) => e.preventDefault();

	const { mutate, isLoading } = useMutation(uploadCustomers, {
		onSuccess: ({ message }) => {
			showSuccessToast(message);
			queryClient.invalidateQueries(["customers"]);
			closePortal();
		},
	});

	const handleSubmit = async (e) => {
		const formData = new FormData();
		formData.append("customer_file", file);
		mutate(formData);
	};

	return (
		<div className="modal-content tw-grid tw-gap-3">
			<p>Drag your files here or browse to upload</p>

			<div>
				<div className="drop-zone" onDrop={handleDrop} onDragOver={handleDragOver}>
					<input type="file" id="file-upload" onChange={handleFileChange} style={{ display: "none" }} />
					<label htmlFor="file-upload" className="file-upload-label">
						{file ? file.name : "Drag or click to upload"}
					</label>
				</div>
				<a className="tw-text-sm tw-text-primary hover:tw-underline" href="./sample-customers.xlsx" download>
					Download Sample
				</a>
			</div>

			<Button variant="secondary" type="button" className="!tw-w-full" onClick={handleSubmit} disabled={isLoading || !file}>
				{isLoading ? "Uploading..." : "Upload"}
			</Button>
		</div>
	);
};

export default BulkCustomerModal;
